import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
const base_url = process.env.REACT_APP_API_URL;
const ColorGameModal = ({
  isOpen,
  onClose,
  color,
  number,
  title,
  duration,
  game,
  period,
}) => {
  const token = localStorage.getItem("token");
  const [balance, setBalance] = useState(1);
  const [quantity, setQuantity] = useState(1);
  const [multiplier, setMultiplier] = useState(1);
  const [agreed, setAgreed] = useState(true);

  const balanceOptions = [1, 10, 100, 1000];
  const multipliers = [1, 5, 10, 20, 50, 100];
  const totalAmount = balance * quantity * multiplier;

  const size =
    color[0] == "#5088D3" ? "Small" : color[0] == "#DD9138" ? "Big" : "";

  let definedColor = "";
  if (!number) {
    definedColor =
      color[0] == "#1AB355"
        ? "Green"
        : color[0] == "#9B48DB"
          ? "Violet"
          : color[0] == "#D23838"
            ? "Red"
            : "";
  }

  if (!isOpen) return null;

  // number submit
  const handleBetSubmit = async (
    gameStr,
    definedColor,
    number,
    size,
    totalAmount,
    period,
  ) => {
    try {
      const response = await axios.post(
        `${base_url}/api/post/wingoGameBet`,
        {
          period,
          game: gameStr,
          number,
          color: definedColor,
          size,
          betAmount: totalAmount,
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      // console.log(response);

      if (response.data.success === true) {
        // toast.success("Bet placed successfully!");
        onClose();
      } else {
        toast.error(
          response.data.message || response.data.data?.message || "Bet failed!",
        );
      }
    } catch (error) {
      console.error("❌ Error submitting game number:", error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <div
      className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-end pb-3"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: 10, // Higher than other elements in ColorGame
        borderRadius: "inherit",
      }}
    >
      <div
        className="w-100 mx-3 text-white rounded-top-4 overflow-hidden"
        style={{
          backgroundColor: "#1e1b2e",
          maxHeight: "90%",
          position: "fixed",
          bottom: 0,
          maxWidth: "375px",
        }}
      >
        {/* Header */}
        <div
          className="position-relative"
          style={{ backgroundColor: "#2B3270" }}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center h-100 p-1 text-center"
            style={{
              clipPath: "polygon(100% 0, 100% 67%, 50% 95%, 0 67%, 0 0)",
              background: `${
                color.length === 1
                  ? color[0]
                  : color.length === 2 && color[0] === "#1AB355"
                    ? "linear-gradient(45deg, " + color[0] + ", #9B48DB)"
                    : "linear-gradient(45deg, " + color[0] + ", #9B48DB)"
              }`,
              height: "5rem",
            }}
          >
            <h3 className="text-center">{title}</h3>

            <p className="text-center">
              Select{" "}
              {number || number === 0
                ? number
                : color[0] == "#1AB355"
                  ? "Green"
                  : color[0] == "#9B48DB"
                    ? "Violet"
                    : color[0] == "#5088D3"
                      ? "Small"
                      : color[0] == "#DD9138"
                        ? "Big"
                        : "Red"}
            </p>
          </div>
        </div>

        {/* Balance */}
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="mb-2" style={{ fontSize: "0.875rem" }}>
              Balance
            </p>
            <div className="d-flex gap-1 flex-wrap justify-content-end">
              {balanceOptions.map((val) => (
                <button
                  key={val}
                  onClick={() => setBalance(val)}
                  className="border-0 rounded"
                  style={{
                    padding: "0.25rem 0.5rem",
                    borderRadius: "6px",
                    fontSize: "0.75rem",
                    backgroundColor: balance === val ? color[0] : "#2B3270",
                    color: balance === val ? "white" : "#ddd",
                    minWidth: "2.5rem",
                  }}
                >
                  {val}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Quantity */}
        <div className="p-3 d-flex justify-content-between align-items-center flex-wrap">
          <p className="mb-2" style={{ fontSize: "0.875rem" }}>
            Quantity
          </p>
          <div className="d-flex align-items-center gap-1">
            <button
              className="border-0 rounded text-white"
              onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
              style={{
                width: "2rem",
                height: "2rem",
                fontSize: "1rem",
                backgroundColor: "#2B3270",
              }}
            >
              −
            </button>
            <span
              className="text-center d-flex align-items-center justify-content-center"
              style={{
                width: "4rem",
                height: "2rem",
                backgroundColor: "#374992",
                borderRadius: "4px",
                fontSize: "0.875rem",
              }}
            >
              {quantity}
            </span>
            <button
              className="border-0 rounded text-white"
              onClick={() => setQuantity((prev) => prev + 1)}
              style={{
                width: "2rem",
                height: "2rem",
                fontSize: "1rem",
                backgroundColor: color[0],
              }}
            >
              +
            </button>
          </div>
        </div>

        {/* Multiplier */}
        <div className="p-3 d-flex gap-1 flex-wrap">
          {multipliers.map((x) => (
            <button
              key={x}
              onClick={() => setMultiplier(x)}
              className="border-0 rounded"
              style={{
                padding: "0.25rem 0.75rem",
                borderRadius: "6px",
                fontSize: "0.75rem",
                backgroundColor: multiplier === x ? color[0] : "#2B3270",
                color: multiplier === x ? "white" : "#ddd",
                border: "none",
                minWidth: "3rem",
              }}
            >
              X{x}
            </button>
          ))}
        </div>

        {/* Checkbox */}
        <div className="p-3 d-flex align-items-center gap-2">
          <input
            type="checkbox"
            checked={agreed}
            onChange={() => setAgreed(!agreed)}
            className="form-check-input"
            style={{ width: "1rem", height: "1rem", accentColor: "#3b82f6" }}
          />
          <label
            className="form-check-label ms-4"
            style={{ fontSize: "0.875rem" }}
          >
            I agree <span style={{ color: "red" }}>《Pre-sale rules》</span>
          </label>
        </div>

        {/* Buttons */}
        <div className="mt-2 d-flex justify-content-between">
          <button
            onClick={onClose}
            className="border-0 w-25 border-0 text-white p-2"
            style={{
              backgroundColor: "#2B3270",
            }}
          >
            Cancel
          </button>
          <button
            className="border-0 w-75 border-0 text-white p-2"
            style={{
              backgroundColor: color[0],
            }}
            onClick={() =>
              handleBetSubmit(
                game,
                definedColor,
                number,
                size,
                totalAmount,
                period,
              )
            }
            disabled={!agreed}
          >
            Total Amount {totalAmount}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColorGameModal;
